import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import {pricingActions} from "_actions";
import styles from "./Styles.module.css";

class Pricing extends Component {
    componentDidMount() {
        const { dispatch } = this.props
        dispatch(pricingActions.getAll())
    }

    render() {
        const { all_pricing } = this.props
        return (
            <div className="main-content-wrapper top-rel-100 margin-0-40">
                <div className={styles.rateContainer}>
                    <Link to="/create-pricing-rate" className={`btn btn-success pull-right ${styles["mb15"]}`}>
                        Create Pricing Rate
                    </Link>
                    <table className="table table-responsive clear-both">
                        <thead>
                        <tr>
                            <th>Currency</th>
                            <th>Amount</th>
                            <th>Description</th>
                            <th>{''}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {all_pricing && all_pricing.length > 0 && all_pricing.map(pricing =>
                            <tr key={pricing.id}>
                                <td className={styles.alignMiddle}>
                                    {pricing.currency &&
                                    `${pricing.currency.label} (${pricing.currency.code})`
                                    }
                                    {! pricing.currency &&
                                    'Unavailable'
                                    }
                                </td>
                                <td className={styles.alignMiddle}>{pricing.amount}</td>
                                <td className={styles.alignMiddle}>{pricing.label}</td>
                                <td className={styles.alignMiddle}>
                                    <Link to={`/edit-pricing-rate/${pricing.id}`} className="btn btn-info btn-sm">
                                        Edit Pricing
                                    </Link>
                                </td>
                            </tr>
                        )}
                        {all_pricing && all_pricing.length === 0 &&
                        <tr>
                            <td className={styles.noRates} colSpan="3">
                                No Payout Rates have been previously added
                            </td>
                        </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { pricing: { all_pricing }} = state
    return {
        all_pricing
    }
}

let pricingConnect = connect(mapStateToProps)(Pricing)

export { pricingConnect as Pricing }